import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CustomizedLabels, Job } from '../../../../../../shared/models/models';
import { SettingsProvider } from '@services/settings/settings';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'invoice-job-info',
	template: require('./invoice-job-info.html'),
	styles: [require('./invoice-job-info.scss')]
})
export class InvoiceJobInfoComponent implements OnInit, OnDestroy {
	@Input() job: Job;

	private shootsLabelName: string;
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(private settingsService: SettingsProvider) {}

	ngOnInit(): void {
		this.subscribeToCustomizeLabelsChange();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(customizeLabels: CustomizedLabels): string =>
					(this.shootsLabelName = customizeLabels.mainShootLabel)
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.ts